import './src/style/plotter.scss';
import Plotter from './src/js/plotter.js';
export default Plotter;
